import { Rule } from '../../Rules'

const bugFixesRules: Array<Rule> = [
  {
    details: 'The price calculation for Dutch Auctions were set to a curve that brings the price down to near zero in about 3 months.',
    reason:
      'The original rules had this curve set at 12 months, and a bug in versions 1 & 2 of the contracts made it run at a pace that was about 7 days.  As a middle ground, we adjusted the curve to be about 3 months.',
    summary: 'Dutch Auction price calculation.',
  },
]

export default bugFixesRules
